/**
 * Load key API and IDE data and show a loading progress indicator before
 * calling a callback. This is very similar to the fetch_everything
 * controller.
 */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import async from 'async';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

function app_load_progress_fetch(data_loaded_callback) {
    var active_account = globalCh.request('active_account');

    // We're going to apply this function to a bunch of collections
    // so that we have some functions to pass to async.
    // async is use here mainly to actuate the loading screen.
    function fetch_collection(collection, fetch_funcname, callback) {
        function success() {
            loading_status.set('completed',
                loading_status.get('completed') + 1
            );
            callback(null, collection);
        }
        function error(xhr) {
            callback(xhr.statusText, null);
        }

        var options = { merge: true };
        if (collection.model && collection.model.type === 'product') {
            _.extend(options, {
                remove: false,
                data: {
                    'filter[owner.id]': active_account.id
                }
            });
        }
        collection[fetch_funcname](options).then(success, error);
    }

    // An object we'll use to collect the functions we want to call asynchronously
    var async_funcs = {};

    var accounts = apiCh.request('account');
    var roles = apiCh.request('account_role');
    var grants = apiCh.request('grant');
    var products = apiCh.request('product');

    var ide_models = {
        devices:            _.partial(fetch_collection, active_account.devices, 'fetch')
    };
    var v5_funcs = {
        accounts:           _.partial(fetch_collection, accounts, 'fetch_all'),
        roles:              _.partial(fetch_collection, roles, 'fetch_all'),
        grants:             _.partial(fetch_collection, grants, 'fetch_all'),
        products: _.partial(fetch_collection, products, 'fetch'),
    };

    _(async_funcs).extend(ide_models);
    _(async_funcs).extend(v5_funcs);

    // let the visitor know we are doing something,
    // a loading screen is a start
    var loading_status = new Backbone.Model({
        completed: 0,
        total: Object.keys(async_funcs).length
    });

    // Update the progress bar when each component is loaded
    loading_status.on('change:completed', function(model, completed) {
        var loaded = Math.round(completed / model.get('total') * 100);
        $('#loading-container .progress-bar').css('width', loaded + '%');
    });

    // Switch from the spinning gear to the logo and progress bar
    // TODO: Get rid of the gear and show a custom logo before app load (requires DevOps work)
    $('#loading-container .pre-start').hide();
    $('#loading-container .post-start').show();

    // Run the data-loading functions we just set up, asynchronously.
    async.parallel(async_funcs, data_loaded_callback);
}
export default app_load_progress_fetch;
